
import PropTypes from 'prop-types'
import { Typography, colors } from '@mui/material'

const Label = ({
  className,
  variant,
  color,
  shape,
  children,
  style,
  ...rest
}) => {

  const finalStyle = { ...style }

  if (variant === 'contained') {
    finalStyle.backgroundColor = color
    finalStyle.color = '#FFF'
  }
  else {
    finalStyle.border = `1px solid ${color}`
    finalStyle.color = color
  }

  return (
    <Typography
      {...rest}
      sx={{
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        letterSpacing: '0.33px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 0,
        flexShrink: 0,
        borderRadius: shape === 'rounded' ? 10 : '4px',
        lineHeight: '10px',
        fontSize: '12px',
        height: 20,
        minWidth: 20,
        whiteSpace: 'nowrap',
        padding: shape === 'rounded' ? '4px' : '4px 8px',
      }}
      style={finalStyle}
      variant="overline">
      {children}
    </Typography>
  )
}

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  shape: PropTypes.oneOf(['square', 'rounded']),
  style: PropTypes.object,
  variant: PropTypes.oneOf(['contained', 'outlined'])
}

Label.defaultProps = {
  style: {},
  color: colors.grey[600],
  variant: 'contained',
  shape: 'square'
}

export default Label
